import { ROUTE_NAMES, routes } from './../const/linking';

export const getLinkTo = (routeName: ROUTE_NAMES, params: Record<string, string> = {}) =>
  routes[routeName].replace(/:([a-zA-Z]+)/g, (match, $1) => params[$1]);
